function addToCartPopUp() {
    var contain = document.querySelector('#ProductSection-product-template');
    var prodForm = document.querySelector('.product-form');
    var addtocart = document.querySelector('[data-add-to-cart]');
    var addtocarttext = document.querySelector('[data-add-to-cart-text]');
    var dataloader = document.querySelector('[data-loader]');
    var ajaxEnabled = contain.getAttribute('data-ajax-enabled') === 'true';
    var cartBubble = document.querySelector('.cart-item-count');
    var cartPopupQty = document.querySelector('[data-cart-popup-cart-quantity]');
    var cartPopUpItemQty = document.querySelector('[data-cart-popup-quantity]');
    var productQuantityInput = document.querySelector('[data-quantity-input]');
    var  errorMessageWrapper = document.querySelector('[data-error-message-wrapper]');
    var errorMessageText = document.querySelector('[data-error-message]');
    var cartPopupWrapper = document.querySelector('.cart-popup-wrapper');
    var cartPopupDismiss = document.querySelector('.cart-popup__dismiss-button');
    var cartPopupCloseBtn = document.querySelector('.cart-popup__close');
    var cartPopupImageWrapper = document.querySelector('[data-cart-popup-image-wrapper]');
    var cartPopupProductTitle = document.querySelector('[data-cart-popup-title]');
  
    prodForm.addEventListener('submit', function(event) {
      if ( addtocart.getAttribute('aria-disabled') === 'true' && addtocart.getAttribute('aria-disabled') != null ) {
        event.preventDefault();
        return;
      }
  
      if (!ajaxEnabled) return;
  
      event.preventDefault();
  
      _addItemToCart(prodForm);
      _cartPopupClose(cartPopupDismiss);
      _cartPopupClose(cartPopupCloseBtn);
    });
  
    function _addItemToCart(form) {
      _hideCartPopup();
      
      errorMessageWrapper.classList.add('hide');
  
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: serialize(form)
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        if (json.status && json.status !== 200) {
          var error = new Error(json.description);
          error.isFromServer = true;
          throw error;
        }
        addToCartLoadingState();
        setTimeout( function() {
          _setupCartPopup(json);
          _cartPopupProductDetail(json.featured_image.url, json.product_title);
        }, 1000 );
      })
      .catch(function(error) {
        errorMessageWrapper.classList.remove('hide');
        _setErrorMessage(error);
      });
    }
  
    function _setupCartPopup(item) {
      _updateCartPopupContent(item);
    }
    
    function _updateCartPopupContent(item) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(response) {
          return response.json();
        })
        .then(function(cart) {
          __setCartQuantity(cart.item_count);
          _setCartCountBubble(cart.item_count);
          _setCartPopUpItemQty();
          _showCartPopup();
          addToCartLoadingStateDisable();
        })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }
  
    function _cartPopupProductDetail(imgUrl, title) {
      cartPopupImageWrapper.innerHTML = '';
      let img = document.createElement('IMG');
      img.src = imgUrl;
      img.classList.add('cart-popup-item__image');
      img.setAttribute('data-cart-popup-image', '');
  
      cartPopupImageWrapper.appendChild( img );
      cartPopupImageWrapper.classList.remove('hide');
  
      cartPopupProductTitle.textContent = title;
    }
  
    function _setCartCountBubble( count ) {
      cartBubble.textContent = count ;
    }
  
    function __setCartQuantity( count ) {
      cartPopupQty.textContent = count ;
    }
  
    function _setErrorMessage(msg) {
      errorMessageText.textContent = msg.toString().replace('Error: ', '');
    }
  
    function _setCartPopUpItemQty() {
      cartPopUpItemQty.textContent = productQuantityInput.value;
    }
  
    function _showCartPopup() {
      cartPopupWrapper.classList.remove('cart-popup-wrapper--hidden');
    }
  
    function _hideCartPopup() {
      cartPopupWrapper.classList.add('cart-popup-wrapper--hidden');
    }
  
    function _cartPopupClose(cart) {
      cart.addEventListener('click', function(event) {
        event.preventDefault();
        _hideCartPopup();
        cartPopupWrapper.classList.add('is-transitioning');
        setTimeout(function(){
          cartPopupWrapper.classList.remove('is-transitioning');
        }, 500);
      });
    }
  
    function addToCartLoadingState() {
      addtocarttext.classList.add('hide');
      dataloader.classList.remove('hide');
      addtocart.setAttribute('aria-disabled', 'true');
      cartPopupWrapper.classList.add('is-transitioning');
    }
  
    function addToCartLoadingStateDisable() {
      addtocarttext.classList.remove('hide');
      dataloader.classList.add('hide');
      addtocart.removeAttribute('aria-disabled');
      cartPopupWrapper.classList.remove('is-transitioning');
    }
  
    /*!
     * Serialize all form data into a SearchParams string
     * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Node}   form The form to serialize
     * @return {String}      The serialized form data
     */
    function serialize(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
}  

addToCartPopUp();